import { html } from "lit-element";
import { StofwareElement } from "@stofloos/core/base/sw-element/index";
import { SWTemplateProvider } from "@stofloos/utils/sw-template-provider";
import { style } from "./style";

import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";
import {localize} from "@stofloos/actions/localize";
import {hasRole} from "@stofloos/redux-helpers";

export let swSidebarMenuTemplate = new SWTemplateProvider();
export let swSidebarBottomMenuTemplate = new SWTemplateProvider();

class SidebarSimple extends StofwareElement {
	static get styles() {
		return [LayoutFlex, style];
	}
	static get properties() {
		return {
			logo: String,
			menu: Array,
			page: String,
			active: Boolean
		};
	}

	constructor() {
		super();
	}

	render() {
		// language=HTML
		return html`
			<div @click="${this._toggleSideMenu}" ?active="${this.active}" class="side-menu t-white layout vertical">
				<div class="layout horizontal">
					<a href="/" class="layout vertical center-center side-menu-logo t-white"><img src="${this.logo}"/></a>
				</div>
				<div class="side-menu-items layout vertical">
					<label>MENU</label>
					<div style="overflow-x: hidden;overflow-y: auto;" class="side-menu-container layout vertical flex">
						${this.menu && this.menu.length > 0
							? this.menu.map(item => {
									if(item.permissions && item.permissions.acceptedRoles.every(hasRole) === false) {
										return html``;
									}
									return html`
										<a
											?selected="${this.page === item.endpoint}"
											class="side-menu-item layout horizontal"
											href="/${item.endpoint}"
										>
											<sw-icon
												set="${item.iconset ? item.iconset : "fas"}"
												icon="${item.icon}"
											></sw-icon>
											<span style="text-transform: capitalize;">${localize("models::"+item.endpoint, {count: 0})}</span>
										</a>
									`;
							  })
							: ""}
						${swSidebarMenuTemplate.getTemplate(this.page)}
					</div>
				</div>
				${swSidebarBottomMenuTemplate.getTemplate(this.page)}
			</div>
		`;
	}

	close() {
		this.active = false;
	}

	open() {
		this.active = true;
	}

	_toggleSideMenu() {
		this.active = !this.active;
	}
}

window.customElements.define("sidebar-simple", SidebarSimple);
